module.exports = __webpack_public_path__ + "img/kefuCode.1ffe1a1e.png";